import ComplaintSearchService from '../services/complaint-search-service';

export const complaintSearch = {
  namespaced: true,
  state: {
    searchResult: null,
    pageNumber: 0,
    lastSearchConfig: null,
    complaintStatusesCount: null,
  },
  actions: {
    search({ commit, dispatch }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'standard';
      commit('setLastSearchConfig', data);
      return ComplaintSearchService.search(data).then(
        async (result) => {
          await dispatch('getComplaintStatusesCount');
          commit('setIsBusy', false, { root: true });
          commit('setComplaintSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    searchAdvanced({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'advanced';
      commit('setLastSearchConfig', data);
      return ComplaintSearchService.advancedSearch(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setComplaintSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    getComplaintStatusesCount({ commit }) {
      commit('setIsBusy', true, { root: true });
      return ComplaintSearchService.getComplaintStatusesCount()
        .then((result) => {
          commit('setCount', result);
          return result;
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
  },
  mutations: {
    setComplaintSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
    setLastSearchConfig(state, searchconfig) {
      state.lastSearchConfig = searchconfig;
    },
    setSearchPageNumber(state, newPageNumber) {
      state.pageNumber = newPageNumber;
    },
    setCount(state, newCount) {
      state.complaintStatusesCount = newCount;
    },
  },
};
